import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { accessData } from "src/helpers/AppConfig";
import Billing from "./tabs/Billing/Billing";
import AllergicGroups from "./tabs/Allergies/AllergicGroups";
import ResponsiblePersons from "./tabs/Resposible_persons/ResponsiblePersons";
import Participation from "./tabs/Participation/Participation";
import Food from "./tabs/Food/Food";
import EvaluationList from "./tabs/Evaluation/EvaluationList";
import { PermissionCheck } from "src/helpers/PermissionCheck";

const ChildTabs: React.FC = () => {
  const { t } = useTranslation();

  const [activeTab, setActiveTab] = useState<number>(0);

  useEffect(() => {
    if (
      PermissionCheck("children-my-responsible-people-list") ||
      PermissionCheck("children-in-groups-responsible-people-list") ||
      PermissionCheck("children-in-kindergarten-responsible-people-list")
    ) {
      setActiveTab(1);
    } else if (
      PermissionCheck("children-food-edit-in-my-kindergarten") ||
      PermissionCheck("children-food-edit-in-kindergarten")
    ) {
      setActiveTab(4);
    } else {
      setActiveTab(5);
    }
  }, []);

  const handleTabClick = (tab: number) => {
    setActiveTab(tab);
  };

  const allTabs = [
    {
      id: 1,
      name: t("show_child_responsible_persons_tab"),
      permissions: [
        "children-my-responsible-people-list",
        "children-in-groups-responsible-people-list",
        "children-in-kindergarten-responsible-people-list",
      ],
      component: <ResponsiblePersons />,
    },
    {
      id: 2,
      name: t("show_child_billing_tab"),
      permissions: [
        "children-invoice-list-my-child",
        "children-invoice-list-in-groups",
        "children-invoice-list-in-kindergarten",
      ],
      component: <Billing />,
    },
    {
      id: 3,
      name: t("show_child_participation_tab"),
      permissions: [
        "children-attendance-in-kindergarten",
        "children-attendance-in-group",
        "children-attendance-my",
      ],
      component: <Participation />,
    },
    {
      id: 4,
      name: t("show_child_food_tab"),
      permissions: [
        "children-food-edit-my-child",
        "children-food-edit-in-groups",
        "children-food-edit-in-kindergarten",
        "children-food-edit-in-my-kindergarten",
      ],
      component: <Food />,
    },
    {
      id: 5,
      name: t("show_child_allergy_tab"),
      permissions: [
        "children-my-allergy-list",
        "children-in-groups-allergy-list",
        
      ],
      component: <AllergicGroups />,
    },
    {
      id: 6,
      name: t("show_child_evaluation_tab"),
      permissions: [
        "children-evaluation-list-my",
        "children-evaluation-list-in-groups",
      ],
      component: <EvaluationList />,
    },
  ];

  return (
    <div className="customized-tabs">
      <div className="blue-tabs mt-4">
        <div className="tab-buttons mb-4">
          {allTabs.map((tab) =>
            tab.permissions.some((permission) =>
              PermissionCheck(permission)
            ) ? (
              <button
                key={tab.id}
                className={`tab-button${activeTab === tab.id ? " active" : ""}`}
                onClick={() => handleTabClick(tab.id)}
              >
                {tab.name}
              </button>
            ) : (
              ""
            )
          )}
        </div>

        <div className="tab-content">
          {allTabs.map(
            (tab) =>
              activeTab === tab.id && <div key={tab.id}>{tab.component}</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ChildTabs;
